import {
	Box,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputBase,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Typography,
	styled,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import Draft_logo from '../../../assets/logos/greennotePad.png';

import patientDashboard from '../../../assets/images/patientDashboard.png';

import Rejected_logo from '../../../assets/logos/reject visit logo.png';

import Billed_logo from '../../../assets/logos/billed visit logo.png';

import Skip_logo from '../../../assets/logos/hotpinkChecpad.png';

import OtherAppointment from '../../../assets/logos/OtherAppointment.png';

import AllAppointment from '../../../assets/logos/AllApointment.png';

import Approved_logo from '../../../assets/logos/blue.png';

import './Dashboard.css';
import BrandedLoader from '../../components/BrandedLoader/BrandedLoader';

import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';

import SearchIcon from '@mui/icons-material/Search';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import Badge from '@mui/material/Badge';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
	getBatches,
	getLocation,
	getAppointment,
	getPatientList,
	postVisitDatalist,
	getSummaryData,
	getDashboardSummary,
} from '../../services/api/apiManager';
import { useStateValue } from '../../services/state/State';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { actions } from '../../services/state/Reducer';
import moment from 'moment';
import {
	ActivePatients,
	AllAppointments,
	ApprovedVisits,
	BatchesModalBox,
	BilledVisits,
	DraftVisits,
	RejectedVisits,
} from './DashboardModals';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	height: 'auto',
	maxHeight: {
		xs: '86vh',
		sm: '82vh',
		md: '80vh',
		lg: '82vh',
		xl: '80vh',
	},
	width: {
		xs: '94vw',
		sm: '90vw',
		md: '82vw',
		lg: '76vw',
		xl: '70vw',
	},
	maxWidth: '1180px',
	overflow: 'hidden',
	bgcolor: 'white',
	borderRadius: '8px',
	boxShadow: '0 18px 50px rgba(15, 35, 70, 0.22)',
	outline: 'none',
	'&:focus': {
		outline: 'none',
	},
	'&:focus-visible': {
		outline: 'none',
	},
};

const getCappedGridHeight = (rowCount, rowHeight, caps) => {
	const contentHeight = rowCount === 0 ? 220 : Math.min(rowCount, 10) * rowHeight;

	return {
		xs: Math.min(contentHeight, caps.xs),
		lg: Math.min(contentHeight, caps.lg),
		xl: Math.min(contentHeight, caps.xl),
	};
};

const getVisitGridHeight = (rowCount) =>
	getCappedGridHeight(rowCount, 63, { xs: 330, lg: 315, xl: 345 });

const getSummaryGridHeight = (rowCount) =>
	getCappedGridHeight(rowCount, 101, { xs: 330, lg: 315, xl: 345 });

const getTallSummaryGridHeight = (rowCount) =>
	rowCount === 0 ? 220 : Math.min(rowCount, 10) * 101;

export function Dashboard() {
	const navigate = useNavigate();
	const practice_id = localStorage.getItem('practice_id');
	const [dashboardSummary, setDashboardSummary] = useState([]);
	const [patientList, setPatientList] = useState([]);
	const [appointmentList, setAppointmentList] = useState([]);
	const [pendingAppointments, setPendingAppointments] = useState([]);
	const [appointmentLoading, setAppointmentLoading] = useState(false);

	const [openDraft, setOpenDraft] = useState(false);
	const [openApproved, setOpenApproved] = useState(false);
	const [openBilled, setOpenBilled] = useState(false);
	const [openRejected, setOpenRejected] = useState(false);
	const [openActivePatient, setOpenActivePatient] = useState(false);
	const [openAppointments, setOpenAppointments] = useState(false);
	// const [batchesVisitsModal, setBatchesVisitsModal] = React.useState({
	// 	batchName: '',
	// 	modalOpen: false,
	// 	data: [],
	// });
	const [{ user }, dispatch] = useStateValue();

	const [locationId, setLocationId] = useState('');
	const [visits, setVisits] = useState([]);
	const [visitsFetched, setVisitsFetched] = useState(false);
	const [locationsData, setLocationsData] = useState([]); // for All locations Data
	const [location, setLocation] = useState('');  // for location State
	const [loadingLocation, setLoadingLocation] = useState(false);
	// const [batches, setBatches] = useState([]);
	const [status, setStatus] = useState('');
	const practiceID = localStorage.getItem('practice_id');
	const [toDate, setToDate] = useState(dayjs(new Date()));
	const [fromDate, setFromDate] = useState(
		dayjs(new Date()).subtract(30, 'day')
	);

	// handle State Value
	const handleChangeStatus = (event) => {
		setStatus(event.target.value);
	};

	// handle Location Value
	const handleChangeLocation = (event) => {
		setLocation(event.target.value);
	};
	// filter the location summry
	const [locationSummary, setLocationSummary] = useState('');
	const handleChangeLocationSummary = (event) => {
		setLocationSummary(event.target.value);
	};
	// const handleOpenDraft = () => {
	// 	visits?.filter((items) => items?.VisitStatus == 'D')?.length > 0
	// 		? setOpenDraft(true)
	// 		: setOpenDraft(false);
	// };
	// const handleOpenApproved = () => {
	// 	visits?.filter((items) => items?.VisitStatus == 'A')?.length > 0
	// 		? setOpenApproved(true)
	// 		: setOpenApproved(false);
	// };
	// const handleOpenBilled = () => {
	// 	visits?.filter((items) => items?.VisitStatus == 'B')?.length > 0
	// 		? setOpenBilled(true)
	// 		: setOpenBilled(false);
	// };
	const handleOpenDraft = async () => {
		setOpenDraft(true)
		let data = visits;

		// first click API call
		if (!visitsFetched) {
			data = await getVisitListData({ practice_id: practiceID });
			setVisitsFetched(true);
		}
	};
	const handleOpenApproved = async () => {
		setOpenApproved(true)
		let data = visits;

		if (!visitsFetched) {
			data = await getVisitListData({ practice_id: practiceID });
			setVisitsFetched(true);
		}
	};
	const handleOpenBilled = async () => {
		setOpenBilled(true);

		let data = visits;

		if (!visitsFetched) {
			data = await getVisitListData({ practice_id: practiceID });
			setVisitsFetched(true);
		}
	};
	const handleOpenActivePatients = async () => {
		setOpenActivePatient(true);

		// only first time API call
		if (!patientsFetched) {
			await getAllPatients(practice_id);
			setPatientsFetched(true);
		}
	};
	const handleOpenRejected = () => {
		visits?.filter((items) => items?.VisitStatus == 'O')?.length > 0
			? setOpenRejected(true)
			: setOpenRejected(false);
	};

	const handleOpenAppointments = async () => {

		setOpenAppointments(true);
		await fetchAppointments();
	};

	const handleCloseModal = () => setOpenDraft(false);
	const handleCloseApproved = () => setOpenApproved(false);
	const handleCloseBilled = () => setOpenBilled(false);
	const handleCloseRejected = () => setOpenRejected(false);
	const handleCloseAppointments = () => setOpenAppointments(false);
	const handleCloseActivePatient = () => setOpenActivePatient(false);

	// const handleOpenBatchesVisitModal = (data, name) => {
	// 	setBatchesVisitsModal({ modalOpen: true, data: data, batchName: name });
	// };
	// const handleOpenBatchesVisitModal = (data, name, count) => {
	// 	if (count > 0) {
	// 		setBatchesVisitsModal({ modalOpen: true, data: data, batchName: name });
	// 	}
	// };
	// const handleCloseBatchesVisitModal = () => {
	// 	setBatchesVisitsModal({ modalOpen: false, data: [] });
	// };

	const [loading, setLoading] = useState(true); // State to track loading
	const [modalLoading, setModalLoading] = useState(true); // State to track loading
	const [patientListLoading, setPatientListLoading] = useState(false); // State to Patient List loading

	// const [filteredVisitData, setFilteredVisitData] = useState([]);
	const [anchorLoadingEl, setAnchorLoadingEl] = useState(null); // State to track loading

	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const [anchorBatchEl, setAnchorBatchEl] = useState(null);
	const handleBatchClick = (event) => {
		setAnchorBatchEl(event.currentTarget);
	};
	const handleBatchClose = () => {
		setAnchorBatchEl(null);
	};

	// API Calling
	const [search, setSearch] = useState('');
	const [summarySearch, setSummarySearch] = useState('');

	// All message Batches
	// const getAllBatches = async () => {
	// 	try {
	// 		const response = await getBatches();
	// 		if (response?.status === 200) {
	// 			dispatch({ type: actions.SET_BATCHES, payload: response?.data });
	// 			setBatches(response?.data?.reverse());
	// 		} else {
	// 			dispatch({ type: actions.SET_BATCHES, payload: [] });
	// 			setBatches([]);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching data:', error);
	// 	}
	// };

	// get All location list
	const getlocationsData = async () => {
		if (locationsData.length > 0) return;

		try {
			setLoadingLocation(true);

			const response = await getLocation();

			if (response?.status === 200) {
				dispatch({
					type: actions.SET_LOCATIONS,
					payload: response?.data,
				});

				setLocationsData(response?.data || []);
			} else {
				dispatch({
					type: actions.SET_LOCATIONS,
					payload: [],
				});

				setLocationsData([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setLoadingLocation(false);
		}
	};
	const handleOpenLocationsDropdown = () => {
		if (locationsData?.length === 0) {
			getlocationsData();
		}
	};


	// get All Pending Appointments
	const fetchAppointments = async () => {
		try {
			setAppointmentLoading(true);

			// cache data
			if (appointmentList?.length > 0) {
				return appointmentList;
			}

			const res = await getAppointment();

			if (res?.status === 200) {
				const filtered =
					res?.data?.filter(
						(items) =>
							items?.Status === 'P' &&
							items?.patient?.practice_id == practice_id
					) || [];

				setAppointmentList(filtered);

				return filtered;
			}

			setAppointmentList([]);
			return [];
		} catch (error) {
			console.error(error);
			setAppointmentList([]);
			return [];
		} finally {
			setAppointmentLoading(false);
		}
	};
	// pagination
	// Last 30 day visit
	const [page, setPage] = useState(1); // Set the initial page number
	const [pageSize, setPageSize] = useState(10); // Set the initial page size
	const [pagination, setPagination] = useState(null);

	const paginationMenuOpen = (event) => {
		setPagination(event.currentTarget);
	};

	const paginationMenuClose = () => {
		setPagination(null);
	};
	// filter 30 Day visits records 
	const filteredVisitData = dashboardSummary?.recent_visits?.filter((item) => {
		const searchValue = search?.trim().toLowerCase();
		const patientName = `${item?.PatientName}`.toLowerCase();
		const searchMatch =
			searchValue === '' ||
			patientName?.includes(searchValue) ||
			item?.Location?.toLowerCase()?.includes(searchValue);
		const statusMatch = status === '' || item?.Status == status;
		const locationMatch = location === '' || item?.Location == location;
		return searchMatch && statusMatch && locationMatch;
	});

	// filter summary location
	const filterLocation = dashboardSummary?.location_summary?.filter((item) => {
		const selectedLocation =
			locationSummary === '' ||
			item?.LocationName?.toLowerCase()?.includes(
				locationSummary.toLowerCase()
			);
		const searchLocation =
			summarySearch.trim() === '' ||
			item?.LocationName?.toLowerCase()?.includes(
				summarySearch.trim().toLowerCase()
			);
		return selectedLocation && searchLocation;
	});
	const totalItemsVisits = filteredVisitData?.length;
	const totalPagesVisits = Math.ceil(totalItemsVisits / pageSize);

	const startIndex = (page - 1) * pageSize;
	const endIndex = Math.min(startIndex + pageSize, totalItemsVisits);
	const visibleVisitData = filteredVisitData?.slice(startIndex, endIndex) || [];

	const handleChangePageVisits = (newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPageVisits = (size) => {
		setPageSize(size);
		setPage(1);
	};

	// pagination batch
	// const [currentPage, setCurrentPage] = useState(1);
	// const [pageSizeBatch, setPageSizeBatch] = useState(5);
	// pagination location
	const [currentPageLocation, setCurrentPageLocation] = useState(1);
	const [pageSizeLocation, setPageSizeLocation] = useState(10);

	// Filtered batches based on search query
	// const filteredBatchesData = batches?.filter((item) => {
	// 	return (
	// 		item.BatchName &&
	// 		item.BatchName.toLowerCase().includes(search.toLowerCase())
	// 	);
	// });

	// const totalItems = filteredBatchesData?.length;
	// const itemsPerPage = pageSizeBatch;
	// const totalPages = Math.ceil(totalItems / itemsPerPage);

	// // Calculate the starting index of the current page
	// const startIndexBatch = (currentPage - 1) * pageSizeBatch;
	// const endIndexBatch = Math.min(
	// 	startIndexBatch + pageSizeBatch,
	// 	filteredBatchesData?.length
	// );

	const handleChangePage = (newPage) => {
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (e) => {
		setPageSizeBatch(e.target.value);
		setCurrentPage(1);
	};

	// Location summary
	const totalItemsLocation = filterLocation?.length;
	const itemsPerPageLocation = pageSizeLocation;
	const totalPagesLocation = Math.ceil(
		totalItemsLocation / itemsPerPageLocation
	);

	// Location summary Calculate the starting index of the current page
	const startIndexLocation = (currentPageLocation - 1) * pageSizeLocation;
	const endIndexLocation = Math.min(
		startIndexLocation + pageSizeLocation,
		filterLocation?.length
	);
	const visibleLocationData =
		filterLocation?.slice(startIndexLocation, endIndexLocation) || [];
	// Location
	const handleChangePageLocation = (newPage) => {
		setCurrentPageLocation(newPage);
	};

	const handleChangeRowsPerPageLocation = (e) => {
		setPageSizeLocation(e.target.value);
		setCurrentPageLocation(1);
	};

	const [patientsFetched, setPatientsFetched] = useState(false);

	// get All Patient data
	const getAllPatients = async (practice_id) => {
		try {
			setPatientListLoading(true);
			const resp = await getPatientList(practice_id);

			if (resp?.status === 200) {
				const data =
					resp?.data
						?.filter(
							(items) =>
								items?.Inactive == null || items?.Inactive == false
						)
						?.reverse() || [];

				setPatientList(data);
				setPatientListLoading(false);
			} else {
				setPatientList([]);
				setPatientListLoading(false);
			}
		} catch (error) {
			console.log(error);
			setPatientList([]);
			setPatientListLoading(false);
		}
	};


	// get dashboard summary data
	const getDashboardSummaryData = async (practice_id) => {
		try {
			setLoading(true);
			const resp = await getDashboardSummary(practice_id);
			if (resp?.status === 200) {
				setDashboardSummary(resp?.data);
			} else {
				setDashboardSummary([]);
				setLoading(false);
			}
		} catch (error) {
			console.log(`error:`, error);
		} finally {
			setLoading(false);
		}
	};

	// get charge visit list

	const getVisitListData = async (data) => {
		try {
			setModalLoading(true);
			const response = await postVisitDatalist(data);

			if (response?.status === 200 || response?.status === 201) {
				setVisits(response?.data);
				return response?.data || [];
				setModalLoading(false);
			} else {
				setVisits([]);
				return [];
			}
		} catch (error) {
			console.error('Error fetching data:', error);
			setVisits([]);
			return [];
		} finally {
			setModalLoading(false);
		}
	};

	const summarySendData = {
		"practice_id": practice_id,
		"status": null,
		"location_id": null
	};
	useEffect(() => {
		getDashboardSummaryData(summarySendData); // get Dashboard Summary Data
	}, [practice_id]);

	const appointmentTypes = [
		{
			status: 'Draft Visits',
			color: '#FEAB13',
			cardLogoColor: '#fff0e9',
			icon: <ArticleOutlinedIcon />,
			count: dashboardSummary?.top_summary?.[0]?.DraftVisits || 0,
			handleClick: handleOpenDraft,
			trend: '12% vs last 30 days',
		},
		{
			status: 'Approved Visits',
			color: '#3EAE4E',
			cardLogoColor: '#E5F6E8',
			icon: <AssignmentTurnedInOutlinedIcon />,
			count: dashboardSummary?.top_summary?.[0]?.ApprovedVisits || 0,
			handleClick: handleOpenApproved,
			trend: '5% vs last 30 days',
		},
		{
			status: 'Billed Visits',
			color: '#DB8B44',
			cardLogoColor: '#FFEDDC',
			icon: <AttachMoneyOutlinedIcon />,
			count: dashboardSummary?.top_summary?.[0]?.BilledVisits || 0,
			handleClick: handleOpenBilled,
			trend: '8% vs last 30 days',
		},
		{
			status: 'Active Patients',
			color: '#008000',
			cardLogoColor: '#E3FFE7',
			icon: <PersonOutlineOutlinedIcon />,
			count: dashboardSummary?.top_summary?.[0]?.ActivePatients || 0,
			handleClick: handleOpenActivePatients,
			trend: '15% vs last 30 days',
		},
		{
			status: 'Pending Appointments',
			color: '#913EAE',
			cardLogoColor: '#F2ECFE',
			icon: <EventAvailableOutlinedIcon />,
			count: dashboardSummary?.top_summary?.[0]?.PendingAppointments || 0,
			handleClick: handleOpenAppointments,
			trend: '3% vs last 30 days',
		},
	];
	const visitStatusMeta = {
		Approved: { label: 'Approved', color: '#138a36', bg: '#e9f8ed' },
		Billed: { label: 'Billed', color: '#DB8B44', bg: '#fff0e8' },
		Draft: { label: 'Draft', color: '#FEAB13', bg: '#fff7e4' },
		Other: { label: 'Other', color: '#d63939', bg: '#ffecec' },
	};

	const rowsPerPageOptions = (length) => {
		const options = [10, 25, 50, 100, length].filter(
			(option) => option && option <= Math.max(length, 10)
		);
		return [...new Set(options.length ? options : [10])];
	};

	const formatVisitDate = (date) => {
		if (!date) return '-';
		const parsedDate = dayjs(date);
		return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '-';
	};
	const dashboardModal = (
		<Modal
			open={
				openApproved ||
				openRejected ||
				openAppointments ||
				openBilled ||
				openDraft ||
				openActivePatient
			}
			onClose={
				openApproved
					? handleCloseApproved
					: openRejected
						? handleCloseRejected
						: openAppointments
							? handleCloseAppointments
							: openBilled
								? handleCloseBilled
								: openDraft
									? handleCloseModal
									: openActivePatient
										? handleCloseActivePatient
										: ''
			}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={style}>
				<Box
					sx={{
						width: '100%',
						height: '40px',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						backgroundColor: '#fff',
						borderBottom: '1px solid #dfe7f3',
						top: 0,
					}}
				>
					<Box>
						<Typography
							sx={{
								ml: 2,
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '14px',
								color: '#172d58',
							}}
						>
							{openApproved
								? 'Approved Visits Record'
								: openRejected
									? 'Other Visits Record'
									: openAppointments
										? 'Appointment Records'
										: openBilled
											? 'Billed Visits Record'
											: openDraft
												? 'Draft Visits Record'
												: openActivePatient
													? 'Active Patients'
													: ''}
						</Typography>
					</Box>
					<CloseIcon
						fontSize="small"
						onClick={
							openApproved
								? handleCloseApproved
								: openRejected
									? handleCloseRejected
									: openAppointments
										? handleCloseAppointments
										: openBilled
											? handleCloseBilled
											: openDraft
												? handleCloseModal
												: openActivePatient
													? handleCloseActivePatient : ''
						}
						sx={{
							cursor: 'pointer',
							color: '#172d58',
							mr: 1.5,
							borderRadius: '6px',
							'&:hover': { bgcolor: '#f2f6fb' },
						}}
					/>
				</Box>
				{openDraft && (
					<DraftVisits
						draftVisitsDataProp={visits?.filter(
							(items) => items?.VisitStatus === 'D'
						)}
						loading={modalLoading}
					/>
				)}
				{openApproved && (
					<ApprovedVisits
						approvedVisitsDataProp={visits?.filter(
							(items) => items?.VisitStatus === 'A'
						)}
						loading={modalLoading}
					/>
				)}
				{openBilled && (
					<BilledVisits
						billedvisitsDataProp={visits?.filter(
							(items) => items?.VisitStatus === 'B'
						)}
						loading={modalLoading}
					/>
				)}
				{openActivePatient && (
					<ActivePatients activePatientDataProp={patientList} loading={patientListLoading} />
				)}
				{openAppointments && (
					<AllAppointments appointmentsDataProp={appointmentList} loading={appointmentLoading} />
				)}
			</Box>
		</Modal>
	);

	return (
		<Box
			sx={{
				height: 'calc(100vh - 44px)',
				maxHeight: 'calc(100vh - 44px)',
				overflow: 'hidden',
				bgcolor: '#f7f9fd',
				padding: { xs: '12px', md: '18px' },
				fontFamily: 'Poppins',
			}}
		>
			{loading ? (
				<BrandedLoader
					title="Loading dashboard"
					text="Preparing your MaxCharts workspace"
				/>
			) : (
				<Box
					sx={{
						height: '100%',
						minHeight: 0,
						display: 'flex',
						flexDirection: 'column',
						overflowY: { xs: 'auto', lg: 'hidden' },
						overflowX: 'hidden',
						pr: { xs: '2px', lg: 0 },
					}}
				>
					<Grid container spacing={2} sx={{ mb: 2, flexShrink: 0 }}>
						{appointmentTypes?.map((appointment, index) => (
							<Grid item xl={2.4} lg={2.4} md={4} sm={6} xs={12} key={index}>
								<Box
									onClick={appointment.handleClick}
									onKeyDown={(event) => {
										if (event.key === 'Enter' || event.key === ' ') {
											event.preventDefault();
											appointment.handleClick();
										}
									}}
									role="button"
									tabIndex={0}
									sx={{
										bgcolor: '#fff',
										border: '1px solid #e8eef8',
										borderRadius: '8px',
										boxShadow: '0 8px 24px rgba(27, 45, 78, 0.06)',
										p: '12px',
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'space-between',
										cursor: 'pointer',
										transition:
											'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
										outline: 'none',
										'&:hover': {
											transform: 'translateY(-2px)',
											boxShadow: '0 12px 28px rgba(27, 45, 78, 0.1)',
											borderColor: '#d5e0f2',
										},
										'&:focus-visible': {
											boxShadow: `0 0 0 3px ${appointment.cardLogoColor}, 0 12px 28px rgba(27, 45, 78, 0.1)`,
										},
									}}
								>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
										<Box
											sx={{
												width: { xs: 54, sm: 64 },
												height: { xs: 54, sm: 64 },
												borderRadius: '50%',
												bgcolor: appointment.cardLogoColor,
												color: appointment.color,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												'& svg': { fontSize: { xs: 28, sm: 34 } },
											}}
										>
											{appointment.icon}
										</Box>
										<Box sx={{ minWidth: 0 }}>
											<Typography
												sx={{
													color: appointment.color,
													fontWeight: 700,
													fontFamily: 'Poppins',
													fontSize: { xs: '30px', sm: '34px' },
													lineHeight: 1,
												}}
											>
												{appointment.count || 0}
											</Typography>
											<Typography
												sx={{
													color: '#172d58',
													fontWeight: 600,
													fontSize: '12px',
													mt: '8px',
												}}
											>
												{appointment.status}
											</Typography>
										</Box>
									</Box>
								</Box>
							</Grid>
						))}
					</Grid>

					<Grid
						container
						spacing={2}
						sx={{
							flex: { xs: '0 0 auto', lg: 1 },
							minHeight: 0,
							height: "100%",
							alignContent: 'flex-start',
							overflow: { xs: 'visible', lg: 'hidden' },
						}}
					>
						<Grid item xl={6} lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex', height: '100%', }}>
							<DashboardPanel>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										gap: { xs: '10px', lg: '6px', xl: '12px' },
										flexWrap: 'wrap',
										mb: '14px',
										'& > *': {
											flexBasis: { xs: '100%', sm: 'auto', lg: 'auto' },
										},
									}}
								>
									<Typography
										sx={{
											color: '#172d58',
											fontFamily: 'Poppins',
											fontSize: { xs: '15px', lg: '13px', xl: '15px' },
											fontWeight: 700,
											mr: { xs: 0, xl: '4px' },
											whiteSpace: 'nowrap',
										}}
									>
										Last 30 day visits
									</Typography>
									<SearchField
										sx={{
											flex: { xs: '1 1 100%', sm: '1 1 220px', lg: '1 1 150px', xl: '1 1 260px' },
										}}
									>
										<SearchIcon sx={{ fontSize: 18, color: '#6981ad' }} />
										<InputBase
											value={search}
											onChange={(e) => {
												setSearch(e.target.value);
												setPage(1);
											}}
											placeholder="Search patient or location..."
											sx={{ fontFamily: 'Poppins', fontSize: '12px', flex: 1 }}
										/>
									</SearchField>
									{/* All Status */}
									<FilterSelect
										value={status}
										onChange={handleChangeStatus}
										displayEmpty
										size="small"
										sx={{ flex: { xs: '1 1 100%', sm: '0 0 145px', lg: '0 0 112px', xl: '0 0 145px' } }}
									>
										<MenuItem value="">Status</MenuItem>
										<MenuItem value="Approved">Approved</MenuItem>
										<MenuItem value="Billed">Billed</MenuItem>
										<MenuItem value="Draft">Draft</MenuItem>
										<MenuItem value="Other">Others</MenuItem>
									</FilterSelect>
									{/* All locations */}
									<FilterSelect
										value={location}
										onChange={handleChangeLocation}
										onOpen={handleOpenLocationsDropdown}
										displayEmpty
										size="small"
										sx={{ flex: { xs: '1 1 100%', sm: '0 0 145px', lg: '0 0 118px', xl: '0 0 145px' } }}
										MenuProps={{
											PaperProps: {
												sx: {
													maxHeight: 220,
												},
											},
										}}
									>
										<MenuItem value="">All Location</MenuItem>
										{loadingLocation ? (
											<MenuItem disabled>Loading...</MenuItem>
										) : (
											locationsData?.map((item, index) => (
												<MenuItem
													key={index}
													value={item?.Name}
												>
													{item?.Name}
												</MenuItem>
											))
										)}
										{/* {locationsData?.map((item, index) => (
											<MenuItem key={index} value={item?.item?.Name}>
												{item?.Name}
											</MenuItem>
										))} */}
									</FilterSelect>
								</Box>
								<Box
									sx={{
										border: '1px solid #e6edf7',
										borderRadius: '6px',
										flex: 1,
										minHeight: 0,
										display: 'flex',
										flexDirection: 'column',
										overflow: 'hidden',
										scrollbarWidth: 'thin',
									}}
								>
									<Grid container sx={{ ...tableHeaderSx, flexShrink: 0 }}>
										<Grid item xs={4}>PATIENT NAME</Grid>
										<Grid item xs={3}>LOCATION</Grid>
										<Grid item xs={2}>STATUS</Grid>
										<Grid item xs={2}>VISIT DATE</Grid>
										<Grid item xs={1}></Grid>
									</Grid>
									<Box
										sx={{
											flex: 1,
											minHeight: 0,
											overflowY: 'auto',
											minWidth: { xs: 760, md: 'auto' },
											scrollbarWidth: 'thin',
											'&::-webkit-scrollbar': {
												width: '6px',
											},
											'&::-webkit-scrollbar-thumb': {
												backgroundColor: '#c7d4e8',
												borderRadius: '999px',
											},
										}}
									>
										{visibleVisitData?.map((item, index) => {
											const statusInfo =
												visitStatusMeta[item?.Status] || {
													label: item?.Status === null ? 'Others' : 'Other',
													color: '#d63939',
													bg: '#ffecec',
												};
											return (
												<Grid container key={index} sx={tableRowSx}>
													<Grid item xs={4}>
														<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
															<RowAvatar>
																<PersonOutlineOutlinedIcon fontSize="small" />
															</RowAvatar>
															<Typography
																onClick={() => {
																	navigate('/editCharge', {
																		state: { pastVisitId: item?.VisitId },
																	});
																}}
																sx={{
																	color: '#1664ff',
																	fontSize: '12px',
																	fontWeight: 700,
																	cursor: 'pointer',
																}}
															>
																{item?.PatientName || '-'}
															</Typography>
														</Box>
													</Grid>
													<Grid item xs={3}>
														<Typography sx={tableTextSx}>{item?.Location || '-'}</Typography>
													</Grid>
													<Grid item xs={2}>
														<StatusPill sx={{ color: statusInfo.color, bgcolor: statusInfo.bg }}>
															<Box
																component="span"
																sx={{
																	width: 6,
																	height: 6,
																	borderRadius: '50%',
																	bgcolor: statusInfo.color,
																}}
															/>
															{statusInfo?.label}
														</StatusPill>
													</Grid>
													<Grid item xs={2}>
														<Typography sx={{ ...tableTextSx, color: '#172d58', fontWeight: 700 }}>
															{formatVisitDate(item?.VisitDate)}
														</Typography>
													</Grid>
													<Grid item xs={1} sx={{ textAlign: 'right' }}>
														<IconButton
															size="small"
															onClick={() => {
																navigate('/editCharge', {
																	state: { pastVisitId: item?.VisitId },
																});
															}}
															sx={{ color: '#1f66ff' }}
														>
															<KeyboardArrowRightIcon fontSize="small" />
														</IconButton>
													</Grid>
												</Grid>
											);
										})}
										{filteredVisitData?.length === 0 && <EmptyState>No Records Found</EmptyState>}
									</Box>
								</Box>
								<PaginationFooter>
									<Typography sx={paginationTextSx}>Rows per page:</Typography>
									<Select
										value={pageSize}
										onChange={(e) => handleChangeRowsPerPageVisits(e.target.value)}
										size="small"
										sx={paginationSelectSx}
									>
										{rowsPerPageOptions(filteredVisitData?.length).map((option) => (
											<MenuItem key={option} value={option}>
												{option}
											</MenuItem>
										))}
									</Select>
									<Typography sx={{ ...paginationTextSx, mx: 2 }}>
										{`${totalItemsVisits > 0 ? startIndex + 1 : 0}-${endIndex} of ${totalItemsVisits}`}
									</Typography>
									<PagerButton onClick={() => handleChangePageVisits(page - 1)} disabled={page === 1}>
										<ArrowBackIosNewIcon sx={{ fontSize: 13 }} />
									</PagerButton>
									<PagerButton
										onClick={() => handleChangePageVisits(page + 1)}
										disabled={page === totalPagesVisits || totalPagesVisits === 0}
									>
										<ArrowForwardIosIcon sx={{ fontSize: 13 }} />
									</PagerButton>
								</PaginationFooter>
							</DashboardPanel>
						</Grid>

						<Grid item xl={6} lg={6} md={12} sm={12} xs={12} sx={{ display: 'flex', height: '100%', }}>

							<DashboardPanel>
								<Box
									sx={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										gap: { xs: '10px', lg: '6px', xl: '12px' },
										flexWrap: 'wrap',
										mb: '14px',
										'& > *': {
											flexBasis: { xs: '100%', sm: 'auto' },
										},
									}}
								>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											gap: { xs: '10px', lg: '6px', xl: '12px' },
											flex: 1,
											flexWrap: 'wrap',
										}}
									>
										<Typography
											sx={{
												color: '#172d58',
												fontFamily: 'Poppins',
												fontSize: { xs: '15px', lg: '13px', xl: '15px' },
												fontWeight: 700,
												whiteSpace: 'nowrap',
											}}
										>
											Location Wise Summary
										</Typography>
										<SearchField
											sx={{
												maxWidth: { xs: '100%', lg: 190, xl: 300 },
												flex: { xs: '1 1 100%', sm: '1 1 220px', lg: '1 1 155px', xl: '1 1 260px' },
											}}
										>
											<SearchIcon sx={{ fontSize: 18, color: '#6981ad' }} />
											<InputBase
												value={summarySearch}
												onChange={(e) => {
													setSummarySearch(e.target.value);
													setCurrentPageLocation(1);
												}}
												placeholder="Search location..."
												sx={{ fontFamily: 'Poppins', fontSize: '12px', flex: 1 }}
											/>
										</SearchField>
									</Box>
									<FilterSelect
										value={locationSummary}
										onChange={handleChangeLocationSummary}
										displayEmpty
										size="small"
										sx={{ flex: { xs: '1 1 100%', sm: '0 0 145px', lg: '0 0 118px', xl: '0 0 145px' } }}
										MenuProps={{
											PaperProps: {
												sx: {
													maxHeight: 220,
												},
											},
										}}
									>
										<MenuItem value="">All Locations</MenuItem>
										{dashboardSummary?.location_summary?.map((item, index) => (
											<MenuItem key={index} value={item?.LocationName}>
												{item?.LocationName}
											</MenuItem>
										))}
									</FilterSelect>
								</Box>
								<Box
									// sx={{
									// 	height: getSummaryGridHeight(visibleLocationData?.length),
									// 	'@media (min-height: 850px)': {
									// 		height: getTallSummaryGridHeight(
									// 			visibleLocationData?.length
									// 		),
									// 	},
									// 	overflowY: 'auto',
									// 	pr: '4px',
									// 	scrollbarWidth: 'thin',
									// 	'&::-webkit-scrollbar': {
									// 		width: '6px',
									// 	},
									// 	'&::-webkit-scrollbar-thumb': {
									// 		backgroundColor: '#c7d4e8',
									// 		borderRadius: '999px',
									// 	},
									// }}
									sx={{
										flex: 1,
										minHeight: 0,
										overflowY: 'auto',
										pr: '4px',
										scrollbarWidth: 'thin',

										'&::-webkit-scrollbar': {
											width: '6px',
										},

										'&::-webkit-scrollbar-thumb': {
											backgroundColor: '#c7d4e8',
											borderRadius: '999px',
										},
									}}
								>
									{visibleLocationData?.map((item, index) => (
										<Box key={`${item?.LocationName}-${index}`} sx={summaryRowSx}>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
												<LocationIcon>
													<BusinessOutlinedIcon fontSize="small" />
												</LocationIcon>
												<Box>
													<Typography sx={{ color: '#172d58', fontSize: '13px', fontWeight: 700 }}>
														{item?.LocationName || '-'}
													</Typography>
													<SummaryMeta>
														<PersonOutlineOutlinedIcon sx={{ fontSize: 14 }} />
														Active Patients:
														<Box component="span" sx={{ color: '#138a36', fontWeight: 700 }}>
															{item?.ActivePatients || 0}
														</Box>
													</SummaryMeta>
													<SummaryMeta>
														<EventAvailableOutlinedIcon sx={{ fontSize: 14 }} />
														Upcoming Appointments:
														<Box component="span" sx={{ color: '#172d58', fontWeight: 700 }}>
															{item?.UpcomingAppointments || 0}
														</Box>
													</SummaryMeta>
												</Box>
											</Box>
											{renderSummaryMetric('#FEAB13', 'Draft Visits', item?.DraftVisits || 0)}
											{renderSummaryMetric('#13913a', 'Approved Visits', item?.ApprovedVisits || 0)}
											{renderSummaryMetric('#DB8B44', 'Billed Visits', item?.BilledVisits || 0)}
										</Box>
									))}
									{filterLocation?.length === 0 && <EmptyState>No Records Found</EmptyState>}
								</Box>
								<PaginationFooter>
									<Typography sx={paginationTextSx}>Rows per page:</Typography>
									<Select
										value={pageSizeLocation}
										onChange={handleChangeRowsPerPageLocation}
										size="small"
										sx={paginationSelectSx}
									>
										{rowsPerPageOptions(filterLocation?.length).map((option) => (
											<MenuItem key={option} value={option}>
												{option}
											</MenuItem>
										))}
									</Select>
									<Typography sx={{ ...paginationTextSx, mx: 2 }}>
										{`${totalItemsLocation > 0 ? startIndexLocation + 1 : 0}-${endIndexLocation} of ${totalItemsLocation}`}
									</Typography>
									<PagerButton
										onClick={() => handleChangePageLocation(currentPageLocation - 1)}
										disabled={currentPageLocation === 1}
									>
										<ArrowBackIosNewIcon sx={{ fontSize: 13 }} />
									</PagerButton>
									<PagerButton
										onClick={() => handleChangePageLocation(currentPageLocation + 1)}
										disabled={
											currentPageLocation === totalPagesLocation ||
											totalPagesLocation === 0
										}
									>
										<ArrowForwardIosIcon sx={{ fontSize: 13 }} />
									</PagerButton>
								</PaginationFooter>
							</DashboardPanel>

						</Grid>
					</Grid>
				</Box>
			)}
			{dashboardModal}
		</Box>
	);
}

// Styling
// Custom styled components
const CardLogo = styled(Box)(({ theme }) => ({
	width: '45px',
	height: '45px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginLeft: 'auto',
	marginRight: '10px',
	borderRadius: '50%',
}));
// const DashboardPanel = styled(Box)(() => ({
// 	width: '100%',
// 	background: '#fff',
// 	// border: '1px solid #e8eef8',
// 	border: "1px solid cyan",
// 	borderRadius: '8px',
// 	boxShadow: '0 8px 24px rgba(27, 45, 78, 0.05)',
// 	padding: '12px',
// 	height: '140%', 
// 	minHeight: 0,
// 	display: 'flex',
// 	flexDirection: 'column',
// 	overflow: 'hidden',
// }));


const DashboardPanel = styled(Box)(({ theme }) => ({
	width: '100%',
	background: '#fff',
	border: '1px solid #e8eef8',
	borderRadius: '8px',
	boxShadow: '0 8px 24px rgba(27, 45, 78, 0.05)',
	padding: '12px',
	minHeight: 0,
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	flex: 1
}));
const SearchField = styled(Box)(() => ({
	height: '36px',
	minWidth: 0,
	boxSizing: 'border-box',
	flex: 1,
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	border: '1px solid #dde6f5',
	borderRadius: '6px',
	background: '#fff',
	padding: '0 10px',
}));

const FilterSelect = styled(Select)(() => ({
	height: '36px',
	minWidth: 0,
	maxWidth: '100%',
	borderRadius: '6px',
	background: '#fff',
	fontFamily: 'Poppins',
	fontSize: '12px',
	color: '#172d58',
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#dde6f5',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#c7d4e8',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#9db7e8',
	},
}));

const RowAvatar = styled(Box)(() => ({
	width: 34,
	height: 34,
	borderRadius: '50%',
	background: '#edf3ff',
	color: '#1f66ff',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
}));

const StatusPill = styled(Box)(() => ({
	display: 'inline-flex',
	alignItems: 'center',
	gap: '7px',
	borderRadius: '999px',
	padding: '4px 10px',
	fontFamily: 'Poppins',
	fontSize: '11px',
	fontWeight: 700,
}));

const EmptyState = styled(Box)(() => ({
	minHeight: 220,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: '#60739d',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 600,
}));

const PaginationFooter = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	flexWrap: 'wrap',
	gap: '8px',
	paddingTop: '14px',
}));

const PagerButton = styled(IconButton)(() => ({
	width: 34,
	height: 34,
	border: '1px solid #e4ebf6',
	color: '#1f66ff',
	background: '#fff',
	'&:disabled': {
		color: '#b9c7dc',
	},
}));

const LocationIcon = styled(Box)(() => ({
	width: 44,
	height: 44,
	borderRadius: '50%',
	background: '#edf3ff',
	color: '#1f66ff',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
}));

const SummaryMeta = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	color: '#30466f',
	fontFamily: 'Poppins',
	fontSize: '11px',
	fontWeight: 600,
	marginTop: '5px',
}));

const renderSummaryMetric = (color, label, value) => (
	<Box
		sx={{
			borderLeft: { xs: 'none', md: '1px solid #dfe7f3' },
			pl: { xs: 0, md: 3 },
			textAlign: { xs: 'left', md: 'center' },
		}}
	>
		<Typography sx={{ color: '#60739d', fontSize: '10px', fontWeight: 700 }}>
			{label}
		</Typography>
		<Typography sx={{ color, fontSize: '22px', fontWeight: 700, mt: '6px' }}>
			{value}
		</Typography>
	</Box>
);

const tableHeaderSx = {
	bgcolor: '#f5f8fd',
	color: '#60739d',
	fontSize: '11px',
	fontWeight: 700,
	fontFamily: 'Poppins',
	px: 2,
	py: 1.5,
	minWidth: { xs: 760, md: 'auto' },
};

const tableRowSx = {
	alignItems: 'center',
	px: 2,
	py: '14px',
	borderTop: '1px solid #e9eff8',
	fontFamily: 'Poppins',
	minWidth: { xs: 760, md: 'auto' },
};

const tableTextSx = {
	color: '#253a66',
	fontSize: '12px',
	fontWeight: 600,
};

const paginationTextSx = {
	fontSize: '12px',
	color: '#526890',
	fontWeight: 600,
	fontFamily: 'Poppins',
};

const paginationSelectSx = {
	height: 34,
	minWidth: 58,
	fontSize: '12px',
	fontFamily: 'Poppins',
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#dfe7f3',
	},
};

const summaryRowSx = {
	display: 'grid',
	gridTemplateColumns: {
		xs: '1fr',
		md: '2fr repeat(3, 1fr)',
	},
	gap: { xs: 1.5, md: 0 },
	alignItems: 'center',
	border: '1px solid #e7edf7',
	borderRadius: '8px',
	p: '14px',
	mb: '8px',
	bgcolor: '#fff',
};
